module.exports = "./img/2f2f349dd5f54b6e23a2c0aafdabe5d5.jpg";